import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import Vuex from 'vuex'
import VJsoneditor from 'v-jsoneditor/src/index'

import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'

import './custom.scss'

import { store } from './store/store';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSync, faSquare, faCheckSquare, faTable, faEdit, faSortAmountUp, faSortAmountDown, faTrash, faPlus, faGlobe, faRecycle, faBalanceScale, faPlusCircle, faBars, faUserAlt, faFileInvoiceDollar, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons'
//import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Mixins
import AuthMixin from './components/Mixins/AuthMixin.vue'
import FormMixin from './components/Mixins/FormMixin.vue'
import SubscriptionMixin from './components/Mixins/SubscriptionMixin.vue'

// Form Controls
import TextControl from './components/Controls/TextControl.vue'
import TextareaControl from './components/Controls/TextareaControl.vue'
import SelectListControl from './components/Controls/SelectListControl.vue'
import CheckboxControl from './components/Controls/CheckboxControl.vue'
import RadioButtonListControl from './components/Controls/RadioButtonListControl.vue'
import CheckBoxListControl from './components/Controls/CheckBoxListControl.vue'
import DatePickerControl from './components/Controls/DatePickerControl.vue'
import FileUploadControl from './components/Controls/FileUploadControl.vue'

// Widgets
import PageLoading from './components/Common/PageLoading.vue'
import PageTitle from './components/Common/PageTitle.vue'
import FilteredTable from './components/Common/FilteredTable.vue'
import ContentBlock from './components/Common/ContentBlock.vue'
import Steps from './components/Common/Steps.vue'

import AuthForm from './components/Auth/AuthForm.vue'

// Admin Dashboard
import AdminDashboard from './components/Admin/AdminDashboard.vue'
import SubscriptionsChart from './components/Admin/SubscriptionsChart.vue'

// Pages
import Home from './components/Home/Home.vue'
import ClientHelp from './components/Home/ClientHelp.vue'
import SubscriberHelp from './components/Home/SubscriberHelp.vue'
import About from './components/Home/About.vue'
import TestingNotes from './components/Home/TestingNotes.vue'
import Login from './components/Auth/Login.vue'
import Logout from './components/Auth/Logout.vue'
import EnterpriseWelcome from './components/Auth/EnterpriseWelcome.vue'
import ChangePassword from './components/Auth/ChangePassword.vue'
import VerifyPhoneNumber from './components/Auth/VerifyPhoneNumber.vue'
import VerifyVerificationCode from './components/Auth/VerifyVerificationCode.vue'
import Subscribe from './components/Auth/Subscribe.vue'
import ApplicationUserList from './components/ApplicationUser/List.vue'
import ApplicationUserFields from './components/ApplicationUser/Fields.vue'
import ApplicationUserEdit from './components/ApplicationUser/Edit.vue'
import ContentBlockList from './components/ContentBlock/List.vue'
import ContentBlockFields from './components/ContentBlock/Fields.vue'
import ContentBlockAdd from './components/ContentBlock/Add.vue'
import ContentBlockEdit from './components/ContentBlock/Edit.vue'
import ContentBlockView from './components/ContentBlock/View.vue'
import TemplateList from './components/Template/List.vue'
import TemplateFields from './components/Template/Fields.vue'
import TemplateEdit from './components/Template/Edit.vue'
import SubscriptionList from './components/Subscription/List.vue'
import SubscriptionFields from './components/Subscription/Fields.vue'
import SubscriptionEdit from './components/Subscription/Edit.vue'
import ClientList from './components/Client/List.vue'

import SubscriberDashboard from './components/Subscriber/Dashboard.vue'
import SubscriberManageSubscription from './components/Subscriber/ManageSubscription.vue'
import SubscriberClientView from './components/Subscriber/Client/View.vue'
import SubscriberClientAdd from './components/Subscriber/Client/Add.vue'
import SubscriberClientCheckOut from './components/Subscriber/Client/CheckOut.vue'
import SubscriberClientCheckIn from './components/Subscriber/Client/CheckIn.vue'
import SubscriberChangePaymentMethod from './components/Subscriber/ChangePaymentMethod.vue'

import ClientLanding from './components/Client/Landing.vue'
import ClientForm from './components/Client/Form.vue'
import ClientReview from './components/Client/Review.vue'
import ClientFinal from './components/Client/Final.vue'

import SupporterLanding from './components/Supporter/Landing.vue'
import './registerServiceWorker'

import axios from 'axios'
import EventBus from './components/Common/EventBus.js'
import { isJwtExpired, clearStoredAuth } from './components/Common/JwtUtils.js'

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(require('vue-moment'));
Vue.use(Vuex);
Vue.use(VJsoneditor)

Vue.use(AuthMixin);
Vue.use(FormMixin);
Vue.use(SubscriptionMixin);

Vue.use(GSignInButton);
Vue.use(FBSignInButton);

library.add(faSync, faSquare, faCheckSquare, faTable, faEdit, faSortAmountUp, faSortAmountDown, faTrash, faPlus, faGlobe, faFacebook, faGoogle, faRecycle, faBalanceScale, faPlusCircle, faBars, faUserAlt, faFileInvoiceDollar, faCreditCard);
//library.add(fas);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('page-loading', PageLoading);
Vue.component('page-title', PageTitle);
Vue.component('filtered-table', FilteredTable);
Vue.component('content-block', ContentBlock);
Vue.component('steps', Steps);

Vue.component('auth-form', AuthForm);

Vue.component('text-control', TextControl);
Vue.component('textarea-control', TextareaControl);
Vue.component('select-list-control', SelectListControl);
Vue.component('checkbox-control', CheckboxControl);
Vue.component('radio-button-list-control', RadioButtonListControl);
Vue.component('check-box-list-control', CheckBoxListControl);
Vue.component('date-picker-control', DatePickerControl);
Vue.component('file-upload-control', FileUploadControl);

Vue.component('application-user-fields', ApplicationUserFields);
Vue.component('content-block-fields', ContentBlockFields);
Vue.component('template-fields', TemplateFields);
Vue.component('subscription-fields', SubscriptionFields);
Vue.component('subscriber-dashboard', SubscriberDashboard);

Vue.component('admin-dashboard', AdminDashboard);
Vue.component('subscriptions-chart', SubscriptionsChart);

Vue.config.productionTip = false;

const routes = [
  { path: '/', component: Home, meta: { public: true } },
  { path: '/about', component: About, meta: { public: true } },
  { path: '/testingNotes', component: TestingNotes, meta: { public: true } },
  { path: '/login', component: Login, meta: { public: true } },
  { path: '/logout', component: Logout, meta: { public: true } },
  { path: '/enterpriseWelcome', component: EnterpriseWelcome, meta: { public: true } },
  { path: '/changePassword', component: ChangePassword },
  { path: '/verifyPhoneNumber', component: VerifyPhoneNumber },
  { path: '/verifyVerificationCode', component: VerifyVerificationCode },
  { path: '/subscribe', component: Subscribe, meta: { public: true } },
  { path: '/clientHelp', component: ClientHelp, meta: { public: true } },
  { path: '/subscriberHelp', component: SubscriberHelp },
  //{ path: '/subscriber/formDetail/:id', component: SubscriberFormDetail, props: true },
  //{ path: '/subscriber/client/list', component: SubscriberClientList },
  { path: '/subscriber/changePaymentMethod', component: SubscriberChangePaymentMethod },
  { path: '/subscriber/manageSubscription', component: SubscriberManageSubscription },
  { path: '/subscriber/client/add', component: SubscriberClientAdd },
  { path: '/subscriber/client/:id', component: SubscriberClientView, props: true },
  { path: '/subscriber/client/:id/checkOut', component: SubscriberClientCheckOut, props: true },
  { path: '/subscriber/client/:id/checkIn', component: SubscriberClientCheckIn, props: true },
  { path: '/c/:shortCode', component: ClientLanding, props: true, meta: { public: true } },
  { path: '/client/landing/:shortCode', component: ClientLanding, props: true, meta: { public: true } },
  { path: '/client/form/:formId/page/:pageId', component: ClientForm, props: true },
  { path: '/client/form/:formId/review', component: ClientReview, props: true },
  { path: '/client/form/:formId/final', component: ClientFinal, props: true },
  { path: '/p/:shortCode', component: SupporterLanding, props: true, meta: { public: true } },
  { path: '/applicationUser', component: ApplicationUserList },
  { path: '/applicationUser/:id', component: ApplicationUserEdit, props: true },
  { path: '/contentBlock', component: ContentBlockList },
  { path: '/contentBlock/add', component: ContentBlockAdd },
  { path: '/contentBlock/:id', component: ContentBlockEdit, props: true },
  { path: '/page/:slug', component: ContentBlockView, props: true, meta: { public: true }  },
  { path: '/template', component: TemplateList },
  { path: '/template/:id', component: TemplateEdit, props: true },
  { path: '/subscription', component: SubscriptionList },
  { path: '/subscription/:id', component: SubscriptionEdit, props: true },
  { path: '/client', component: ClientList },
  // { path: '/wireframe/subscriberDashboard', component: WireframeSubscriberDashboard, meta: { public: true } },
  // { path: '/wireframe/inviteClient', component: WireframeInviteClient, meta: { public: true } },
  // { path: '/wireframe/subscriberClientOverview', component: WireframeSubscriberClientOverview, meta: { public: true } },
  // { path: '/wireframe/clientLanding', component: WireframeClientLanding, meta: { public: true } },
  // { path: '/wireframe/clientBio1', component: WireframeClientBio1, meta: { public: true } },
  // { path: '/wireframe/clientBio2', component: WireframeClientBio2, meta: { public: true } },
  // { path: '/wireframe/clientBio3', component: WireframeClientBio3, meta: { public: true } },
  // { path: '/wireframe/clientGad', component: WireframeClientGad, meta: { public: true } },
];

const router = new VueRouter({
  routes // short for `routes: routes`
});

// If the saved login has already expired, drop it so the app doesn't pretend the user is logged in.
// Must run after the router is created: it uses router.match() to check whether the current page is public.
if (localStorage.getItem('jwt') && isJwtExpired(localStorage.getItem('jwt'))) {
    clearStoredAuth();

    const currentPath = (window.location.hash || '#/').substring(1) || '/';
    const isPublic = router.match(currentPath).matched.some(r => r.meta && r.meta.public);

    if (!isPublic && currentPath.indexOf('/login') !== 0)
        window.location.hash = '#/login?expired=1&redirect=' + encodeURIComponent(currentPath);
}

router.beforeEach((to, from, next) => {
  // Token expired while the app was open: log out before deciding where the user can go.
  // (The API doesn't reliably return 401 for an expired token, so we can't rely on the axios interceptor alone.)
  if (localStorage.getItem('jwt') && isJwtExpired(localStorage.getItem('jwt'))) {
    logOutExpiredSession();

    if (!to.matched.some(record => record.meta.public) && to.path !== '/login') {
      next({ path: '/login', query: { redirect: to.fullPath, expired: '1' } });
      return;
    }
  }

  if (router.app.$root.$data && router.app.$root.$data.authenticatedUser && router.app.$root.$data.authenticatedUser.id) {
    // Allow authenticated users through
    next();
  } else if (to.matched.some(record => record.meta.public)) {
    // Allow all users to hit any page marked as public
    next();
  } else {
    // Redirect to the login page, passing the requested page as the redirect param
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  }
});

router.afterEach((to, from) => {
  // gtag('config', window.GA_TRACKING_ID, {
  //   page_path: to.fullPath,
  //   app_name: 'JusticeStory',
  //   send_page_view: true,
  // });
});

// Clears the stored login and the in-memory user so the app treats the user as logged out
function logOutExpiredSession() {
    clearStoredAuth();
    delete axios.defaults.headers.common['Authorization'];

    const root = router.app && router.app.$root;
    if (root && root.$data && root.$data.authenticatedUser) {
        root.$data.authenticatedUser.username = null;
        root.$data.authenticatedUser.id = null;
        root.$data.authenticatedUser.roles = [];
    }
    EventBus.$emit('authenticated', null);
}

// Session expired while the app was open: log out and send the user to the login page
let isHandlingExpiredSession = false;

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error.response && error.response.status;
        const url = (error.config && error.config.url) || '';
        const token = localStorage.getItem('jwt');
        const hadToken = !!token;

        // Expired session = a 401, OR any failed request while the saved token is past its expiry
        // (most API endpoints aren't [Authorize], so an expired token often comes back as 403/500, not 401)
        const sessionExpired = status === 401 || (hadToken && isJwtExpired(token));

        if (sessionExpired && hadToken && url.indexOf('/api/account/') === -1 && !isHandlingExpiredSession) {
            isHandlingExpiredSession = true;

            logOutExpiredSession();

            const done = () => { isHandlingExpiredSession = false; };

            // Already on the login page: keep its existing redirect instead of nesting
            // "/login?...&redirect=/login?..." (which would send the user back to login after logging in)
            const current = router.currentRoute;
            const redirect = current.path === '/login'
                ? (current.query.redirect || '/')
                : current.fullPath;

            router.push(
                { path: '/login', query: { redirect: redirect, expired: '1' } },
                done,
                done
            );
        }

        return Promise.reject(error);
    }
);

new Vue({
  store,
  router,
  render: h => h(App),
  data: {
    authenticatedUser: {
      username: null,
      id: null,
      roles: []
    }
  }
}).$mount('body');
